import { render, staticRenderFns } from "./ArchiveMessage.vue?vue&type=template&id=41611aa7&scoped=true"
import script from "./ArchiveMessage.vue?vue&type=script&lang=js"
export * from "./ArchiveMessage.vue?vue&type=script&lang=js"
import style0 from "./ArchiveMessage.vue?vue&type=style&index=0&id=41611aa7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41611aa7",
  null
  
)

export default component.exports